import _get from 'hs-lodash/get';
import { useCallback, useContext } from 'react';
import { PROPERTY_REFERENCE_TYPES } from '../constants/associations';
import { pluralTypeToSingle } from '../constants/types';
import { PropertiesContext } from '../contexts/properties/context';
const useSelectFilterOptions = ({
  referenceType,
  correlatedField,
  correlatedFieldValue,
  objectType,
  inputValue
}) => {
  const {
    externalOptions
  } = useContext(PropertiesContext);
  return useCallback(options => {
    if (referenceType === PROPERTY_REFERENCE_TYPES.PIPELINE_STAGE && correlatedField && correlatedFieldValue) {
      const correlatedFieldExternalOptions = externalOptions[pluralTypeToSingle[objectType]][correlatedField.referenceType];
      if (correlatedFieldExternalOptions && correlatedFieldExternalOptions.results) {
        const correlatedFieldExternalOption = correlatedFieldExternalOptions.results.find(item => item.id === correlatedFieldValue);
        if (correlatedFieldExternalOption) {
          const valueToFilter = _get(correlatedFieldExternalOption.additionalFields, 'defaultPipelineStageId');
          if (valueToFilter) {
            return options.filter(option => {
              const pipelineId = _get(option.additionalFields, 'pipelineId', '');
              if (inputValue) return pipelineId === correlatedFieldValue && option.label.toLowerCase().includes(inputValue.toLowerCase());
              if (pipelineId) return pipelineId === correlatedFieldValue;
              return true;
            });
          }
        }
      }
    }
    if (inputValue) {
      return options.filter(option => option.label.toLowerCase().includes(inputValue.toLowerCase()));
    }
    return options;
  }, [correlatedField, correlatedFieldValue, externalOptions, objectType, referenceType, inputValue]);
};
export default useSelectFilterOptions;